import React from 'react';
import Agreement from './Agreement';
import Section3 from './Section3';

const BusinessPlans = () => {
  return (
    <div className='px-4 md:px-24 pt-4'>
      <div>
        <h1 className='font-bold text-[10px] md:text-[36px] text-[#03897B]'>PURPOSE</h1>
      </div>

      {/* Image Container */}
      <div className="relative w-full h-[100px] md:h-[427px] rounded-t-[5px] overflow-hidden mt-1">
        {/* Image */}
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746268286/image_67_bpy2m5.png"
          alt="Funding"
          className="w-full h-full object-cover"
        />

        {/* Logo */}
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746014742/image_1717_1_mrc5cr.png"
          alt="Ad Luck Logo"
          className="absolute bottom-6 left-4 md:bottom-12 md:left-8 w-[80px] md:w-[174px]"
        />
      </div>

      {/* Bottom Bar */}
      <div className="w-full h-[30px] md:h-[78px] bg-[#e0e0e0] flex items-center justify-between px-4 md:px-6 font-bold text-sm rounded-b-[5px]">
        <span className='text-[10px] md:text-[24px]'>BUSINESS PLAN</span>
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746014605/Expand_right_13_khjlok.png"
          alt="Arrow"
          className="h-[26px] w-[26px] md:h-[46px] md:w-[47px]"
        />
      </div>

      <div className='md:mt-4 md:mb-14 mt-5 mb-6'>
        <p className='md:text-[18px] text-[8px] font-normal'>
        Ad-Luck positions itself as a trusted intermediary for development partners, streamlining the disbursement of funds to ensure they reach targeted beneficiaries efficiently, transparently, and with measurable impact on community development. <br/>
        Entrepreneurs can access funding from development partners by registering through the Ad-Luck Holdings funding portal. Once registered, their applications are evaluated for compliance with funding criteria. Those who meet the requirements are then eligible to receive financial support.
        </p>
      </div>
   <div className='flex items-center md:space-x-6'>
   <a href='/funding'>
   <div>
      <p className='md:text-[20px] text-[8px] font-bold md:mb-3'>DUE DILIGENCE</p>
              <div className="flex items-center  ml-auto pr-3 md:pr-0 md:mb-1">
                <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[3px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                Due dilligence
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[55px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-[5px] rounded-tr-md font-bold md:rounded-br-[5px] bg-[#F38323] px-2 md:py-1 "
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[423px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
      <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>Select due diligence</p>

            </div>
   </a>
           <a href='/BusinessPlan'>
           <div>
      <p className='md:text-[20px] text-[8px]  font-bold md:mb-3'>BUSINESS PLANS</p>
              <div className="flex items-center  ml-auto pr-3 md:pr-0 md:mb-1">
                <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[3px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                Business plans
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[55px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-[5px] rounded-tr-md font-bold md:rounded-br-[5px] bg-[#F38323] px-2 md:py-1 "
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[423px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
      <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>Select business plans</p>

            </div>
           </a>
         <a href='/CreditScore'>
         <div>
      <p className='md:text-[20px] text-[8px] font-bold md:mb-3'>CREDIT SCORE</p>
              <div className="flex items-center  ml-auto pr-3 md:pr-0 md:mb-1">
                <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[3px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                Credit score
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[55px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-[5px] rounded-tr-md font-bold md:rounded-br-[5px] bg-[#F38323] px-2 md:py-1 "
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[423px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
      <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>Go to credit score</p>

            </div>
         </a>
           <a href='/LocationApplication'>
           <div>
      <p className='md:text-[20px] text-[8px]   font-bold md:mb-3'>LOAN APPLICATION</p>
              <div className="flex items-center  ml-auto pr-3 md:pr-0 md:mb-1">
                <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[3px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                Loan Application
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[55px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-[5px] rounded-tr-md font-bold md:rounded-br-[5px] bg-[#F38323] px-2 md:py-1 "
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[423px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
      <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>Select type of loan</p>

            </div>
           </a>
   </div>
   <div className='md:mt-10 mb-6 mt-5 md:mb-14'>
   <h1 className='md:text-[24px] text-[10px] font-bold mb:mb-5'>BUSINESS PLAN</h1>
        <p className='md:text-[18px] text-[6px] font-normal'>
        As part of the funding application process, Ad-Luck requires applicants to submit a comprehensive business plan outlining their objectives, financial projections, operational strategy, and expected impact. This plan is a key tool in evaluating the viability and sustainability of the proposed venture before funding is approved.
        </p>
      </div>
    
      <div className="leading-[1.2] text-center md:mb-10">
        <h2 className="text-[10px] md:text-[28px] font-bold text-[#03897B]">
        BUSINESS PLAN
        </h2>
        <p className="text-[10px] md:text-[24px] font-normal">
        To be completed by funding applicant
        </p>
      </div>
      <div className="w-full md:mb-4 mb-2">
        <div className="relative">
          <input
            placeholder="Search"
            type="text"
            className="w-full md:h-[50px] h-[30px] text-[#979797] text-[10px] md:text-[16px] font-bold md:p-3 pr-10 p-1  md:px-6 px-3 border-[1px] border-[#C4C4C4] md:rounded-md  rounded-full focus:outline-none focus:ring-2 focus:ring-green-600"
          />
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744490602/Search_k7vxkr.png"
            alt="Search Icon"
            className="w-[18px] h-[15px] md:h-[24px] md:w-[24px] absolute right-5 top-1/2 transform -translate-y-1/2"
          />
        </div>
      </div>
      <div className="flex justify-between md:mt-10 mt-5 ">
<h2 className="text-[10px] md:text-[24px] font-bold text-[#03897B]">
      ENTERPRENEUR
        </h2>
        <h1 className="md:text-[24px] text-[8px] font-bold text-black md:pr-40">ABC Enterprise  | ID NO: XXXXXXXX01</h1>
</div>
<h2 className="text-[10px] md:text-[24px] font-bold md:mt-6 text-[#03897B]">
BUSINESS PLAN
        </h2>
      <div>
        <h2 className="text-[8px] md:text-[24px] font-bold text-[#03897B] mt-6 md:mt-10">
          <span className="text-[#979797]">Section 1 : </span>EXECUTIVE SUMMARY
        </h2>
      </div>
      <div>
        <p className='md:text-[18px] text-[6px] md:mt-2'>
        Green Harvest Farms is a small-scale agricultural enterprise based in [Insert Location], focused on the sustainable cultivation of high-demand vegetables such as spinach, tomatoes, and green peppers. Our mission is to provide fresh, locally grown produce to local markets, retailers, and community feeding schemes, while creating employment opportunities and promoting food security. <br/>
        <br/>
The business operates on a 5-hectare plot of leased land and utilizes environmentally friendly farming practices, including drip irrigation, organic pest control, and crop rotation. With growing demand for fresh produce in urban and peri-urban areas, Green Harvest Farms aims to supply at least 3 tonnes of produce monthly within the first year, scaling up to 8 tonnes by year three.
<br/><br/>
To achieve this, we are seeking funding of R250,000 to cover infrastructure development, input costs (seeds, fertilizers, tools), labor, and initial working capital. The funding will also support capacity building through training and compliance with food safety standards.
<br/><br/>
Green Harvest Farms projects profitability within 18 months, with expected annual revenue growth of 35% as market demand and production scale increase. The enterprise is committed to contributing to local economic development, youth employment, and sustainable farming practices in the region.


        </p>
      </div>
      <Agreement/>
      <Section3/>
      <div className="flex justify-end md:mt-10 md:mb-4 mt-4">
        <button
          className="flex items-center md:gap-2 gap-2  hover:bg-[#0f1f1a] text-black hover:text-white  md:py-3 py-1 rounded-md text-[6px] md:text-lg font-normal italic transition"
        >
          Save
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
            alt="Save Icon"
            className="md:w-11 md:h-11 h-3 w-3"
          />
        </button>
      </div>
         {/* Register Button */}
         <button className="w-full bg-[#03897B] flex justify-center md:mt-3  border-b-[3px] md:py-2 py-1 border-[#FDBD26] text-center md:h-[74px] h-[20px] text-white md:text-[36px] text-[6px] font-bold rounded-md">
      Submit
      </button>
         {/* Buttons */}
         <div className="flex md:gap-4 gap-1  justify-end md:mt-7 mt-2 md:mb-10 mb-5">
        {/* Edit Button */}
        <div>
        <button className="flex items-center justify-between md:w-[230px] w-[100px] md:h-[61px] h-[20px] bg-[#03897B] text-white md:text-[14px] text-[6px] font-bold rounded-[10px] md:px-8 px-4 ">
          <span>EDIT</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690463/Edit_fill_llaa3q.png"
            alt="Edit Icon"
            className="md:w-[35px] h-2  md:h-[38px] w-2 "
          />
        </button>
        <p className='md:text-[14px] text-[6px] md:mt-4  mt-1 font-normal md:px-1 '>
        Edit registration form
        </p>
        </div>


        {/* Save Button */}
    <div>
    <button className="flex items-center justify-between w-[100px] md:w-[230px] h-[20px] md:h-[61px] bg-[#03897B] text-white md:text-[14px]  text-[6px] font-bold  rounded-[10px] px-4">
          <span>SAVE</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690487/Arhive_load_duotone_line_1_hbsukd.png"
            alt="Save Icon"
            className="md:w-[35px] h-2  md:h-[38px] w-2 "
          />
        </button>
        <p className='md:text-[14px]  text-[6px] md:mt-4 mt-1 font-normal md:px-1 '>
        Save registration 
        </p>
    </div>
   <a href='/BusinessPlan1'>
   <div>
    <button className="flex items-center justify-between w-[100px] md:w-[230px] h-[20px] md:h-[61px] bg-[#03897B] text-white md:text-[14px]  text-[6px] font-bold  rounded-[10px] px-4">
          <span>SEND</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746037449/Send_hor_fill_lfkysb.png"
            alt="Save Icon"
            className="md:w-[35px] h-2  md:h-[38px] w-2 "
          />
        </button>
        <p className='md:text-[14px]  text-[6px] md:mt-4 mt-1 font-normal md:px-1 '>
        Send Due diligence form
        </p>
    </div>
   </a>
      </div>
         
    </div>
  );
};

export default BusinessPlans;
